import { render } from "./FootTab.vue?vue&type=template&id=adfee50a&scoped=true"
import script from "./FootTab.vue?vue&type=script&lang=js"
export * from "./FootTab.vue?vue&type=script&lang=js"

import "./FootTab.vue?vue&type=style&index=0&id=adfee50a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-adfee50a"

export default script